<!-- 查看挑战书 -->
<template>
  <div class="toast-container" @click.stop>
    <div class="image-container" v-if="info.img">
      <img class="image" :src="info.img" alt="" />
      <div class="close iconfont icon-cha" @click="bindclose"></div>
    </div>
    <div v-else class="empty">
      <img
        class="empty-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-03/20afe4669b39e810f18efc79e43af1b1_wh=645_336.webp"
        alt=""
      />
      <div class="message">主教练还未上传挑战书，记得提醒TA哦</div>
      <div class="btn" @click="bindclose">知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindclose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.toast-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.image-container {
  position: relative;
  width: 300px;
  height: 400px;
  box-sizing: border-box;
  background: #dbdbdb;
  border: 1px solid #979797;

  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .close {
    position: absolute;
    left: 50%;
    bottom: -30px;
    transform: translate(-50%, 100%);
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    border: 1px solid #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
}

.empty {
  width: 275px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
  padding: 32px 10px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .empty-image {
    width: 214px;
    margin-bottom: 10px;
  }

  .message {
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.7);
    line-height: 20px;
    margin-bottom: 20px;
  }

  .btn {
    width: 227px;
    height: 40px;
    background: #ff3b86;
    border-radius: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
